module.exports = __webpack_public_path__ + "img/courses1.3f9935e4.jpg";